// extracted by mini-css-extract-plugin
export default {"animateDrop":"SlideTransition-module__animateDrop___BsY5g","main":"SlideTransition-module__main___YldeC"};